import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ScreenTContext from 'src/context/LockScreenProvider';

/**
 * @function LoadSpinner
 * @description Renderiza el bloqueo de pantalla.
 * @returns {React.JSX.Element}
 * @example
 * <LoadSpinner />
 *
 * const myFunction = () => {
 * const { lockScreen, setLockScreen } = ScreenTContext();
 *		<button onClick={() => setLockScreen(!lockScreen)}>Lock/Unlock</button>
 *		<button onClick={() => setLockScreen(true)}>Lock</button>
 *		<button onClick={() => setLockScreen(false)}>Unlock</button>
 * }
 */
export default function LoadSpinner(): React.JSX.Element {
    const { lockScreen } = ScreenTContext();

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={lockScreen}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}
